module.exports = __webpack_public_path__ + "9f2f448211dd6e7428e84f10a856cdc4.jpg";